import script from "./iHeader.vue?vue&type=script&setup=true&name=iHeader&lang=js"
export * from "./iHeader.vue?vue&type=script&setup=true&name=iHeader&lang=js"

import "./iHeader.vue?vue&type=style&index=0&id=26ae8dd6&lang=less&scoped=true"

import exportComponent from "G:\\project\\csadmin-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26ae8dd6"]])

export default __exports__